import React from "react";

const I9 = React.forwardRef((props, ref) => {
    return <iframe ref={ref} src="/forms/i-9/form.html" title="I-9 Form" />;
});

export default I9;
